export default "__VITE_ASSET__DwuNUlGd__"